var map = {
	"./cake.webp": 1987,
	"./crown-blue.webp": 1988,
	"./crown.webp": 1989,
	"./pocket.webp": 1990,
	"./present.webp": 1991,
	"./relegation.webp": 1992,
	"./t-deposit.webp": 1993,
	"./t-turnover.webp": 1994,
	"./vip-bg.webp": 1995,
	"./vip1.gif": 1996,
	"./vip1.webp": 1997,
	"./vip10-bg.webp": 1998,
	"./vip10.gif": 1999,
	"./vip10.webp": 2000,
	"./vip11-bg.webp": 2001,
	"./vip11.gif": 2002,
	"./vip11.webp": 2003,
	"./vip12-bg.webp": 2004,
	"./vip12.gif": 2005,
	"./vip12.webp": 2006,
	"./vip2.gif": 2007,
	"./vip2.webp": 2008,
	"./vip3.gif": 2009,
	"./vip3.webp": 2010,
	"./vip4.gif": 2011,
	"./vip4.webp": 2012,
	"./vip5.gif": 2013,
	"./vip5.webp": 2014,
	"./vip6.gif": 2015,
	"./vip6.webp": 2016,
	"./vip7.gif": 2017,
	"./vip7.webp": 2018,
	"./vip8.gif": 2019,
	"./vip8.webp": 2020,
	"./vip9.gif": 2021,
	"./vip9.webp": 2022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;